export type ObjectType = 'user' | 'organisation' | 'committee';
